export const formatPreviousProposalDate = (value?: string | null): string => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const resolvePreviousProposalTotalPrice = (
  proposal: { totalPrice?: unknown; invoiceAmount?: unknown } | null | undefined,
  source?: string | null
): number | null => {
  const rawValue = source === 'upcoming-projects'
    ? proposal?.invoiceAmount
    : proposal?.totalPrice;
  const value = Number(rawValue);

  return Number.isFinite(value) ? value : null;
};

export const shouldUseProposalReportAttributes = (source?: string | null): boolean => {
  return source === 'upcoming-projects';
};
